module.exports = __webpack_public_path__ + "static/img/operateWeek.e23a487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateWeek.jpg
// module id = whai
// module chunks = 1